import reducers from './reducers';
import rootSaga from './sagas';

export const getRootModule = () => ({
  id: 'Root',
  reducerMap: reducers,
  sagas: [rootSaga]
});
